import { DateFilter } from '../../Shared';
import { ClientsFilter } from '../ClientsFilter';

export const FiltersPanel = ({
  filters,
  onChangeFilters,
  clients,
  isClientsLoading,
  isClientsError,
}) => {
  return (
    <>
      <ClientsFilter
        clientIds={filters.clientIds}
        onChangeClientIds={onChangeFilters}
        clients={clients}
        isClientsLoading={isClientsLoading}
        isClientsError={isClientsError}
      />
      <DateFilter
        selectedDate={filters.selectedDate}
        onChangeSelectedDate={onChangeFilters}
      />
    </>
  );
};
